import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

export interface IDisplayImageProps {
    altText: string;
    showImage: boolean;
    src: string;
    onError: () => void;
    onLoad: () => void;
    role: string;
}

export const DisplayImage = ({ role, altText, src, onError, onLoad, showImage }: IDisplayImageProps) => {
    const [ref, inView] = useInView({ threshold: 0, triggerOnce: true });

    return (
        <Image
            ref={ref}
            alt={altText}
            aria-hidden={!showImage}
            onError={onError}
            onLoad={onLoad}
            role={role}
            src={inView ? src : undefined}
            style={{
                opacity: showImage ? 1 : 0,
            }}
        />
    );
};

const Image = styled.img`
    height: 100%;
    width: 100%;
    transition: opacity linear 0.2s;
    position: absolute;
    object-fit: cover;
    object-position: center;
`;
